import { useLang } from "@/lib/i18n";
import { GRADIENTS } from "@/lib/meta";
import { Camera } from "lucide-react";

export default function Placeholder({ variant = 0, label, className = "", aspect = "aspect-[3/4]", children }) {
  const { t } = useLang();
  const g = GRADIENTS[variant % GRADIENTS.length];
  const showLabel = label === undefined || label !== "";
  return (
    <div className={`ph ${aspect} ${className}`} data-testid="photo-placeholder">
      <div className="absolute inset-0" style={{ backgroundImage: g }} />
      {showLabel && (
        <span className="ph-label">
          <Camera className="w-3 h-3" strokeWidth={1.5} />
          {label !== undefined ? label : t.common.placeholderLabel}
        </span>
      )}
      <span className="ph-mark" title={t.common.placeholderNote}>
        <Camera className="w-4 h-4" strokeWidth={1} />
      </span>
      {children}
    </div>
  );
}
